module.exports = __webpack_public_path__ + "static/img/logo-m.2e8f8b65.svg";